import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { CommunicationService } from 'src/app/services/communication';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Logger } from 'projects/common/src/app/classes';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportCartirProductionService extends Logger {
  private baseUrl: string;
  constructor(
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * get data report hourmeter and fuel
   */
  public GetReportCartir(selectedFilters: IOutputFilter): any {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetTaskReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * get data excel report hourmeter and fuel
   */
  public GetReportCartirExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetTaskReportDocument/`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Get Data report Cartir vs production
   *
   * @param selectedFilter
   * @returns
   */
  public GetReportCartirVsProduction(selectedFilter: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilter);
    const url = `${this.baseUrl}/Report/GetLoopsTaskReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Download Data report Cartir vs production
   *
   * @param params
   * @returns
   */
  public DownloadReportCartirProductionExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetLoopsTaskReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * set Params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      mineId: String(selectedFilters.mineId),
      companyId: selectedFilters.companyId,
    };
  }
}
